/**
 * Internal early-access route. Replaces the (expiring) Typeform — the
 * "Request early access" CTAs now point at our first-party `/request-access`
 * form.
 */
export const EARLY_ACCESS_URL = "/request-access"

/** Public self-service entry point; account and billing policy remain in onboarding. */
export const GET_STARTED_URL = "/auth/signup"

/** Google Calendar booking page for demo calls. */
export const BOOK_DEMO_URL = "https://calendar.app.google/U59cE1XeU7P37vZR9"
